import {Component, OnDestroy, OnInit, Input, ViewChild, AfterViewInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ValidateService } from 'src/app/modules/product/services/validate.service';
import { MasterDataProductService } from 'src/app/modules/product/services/master-data-product.service';
import { ProductService } from '../../product.service';
import { DataService } from '../../services/data.service';
import { ToastrService } from 'ngx-toastr';
import { EventManager } from 'src/app/core';
import { Constant } from 'src/app/core/constant';
import { Fee } from '../../models/fee.model';
import { EditComponent } from '../../../../shared/components/edit.component';
import { EditFeeComponent } from '../edit-fee/edit-fee.component';
declare let $: any;
@Component({
  selector: 'app-new-sell-fee-fund',
  templateUrl: './new-sell-fee-fund.component.html',
  styleUrls: ['./new-sell-fee-fund.component.scss'],
  providers: [ValidateService, DataService],
})
export class NewSellFeeFundComponent extends EditComponent implements OnInit, OnDestroy {
  @Input() startDate: any;
  @Input() fees: any[] = [];
  @Input() currentFees: any[] = [];
  @Input()  relationalOperators: any[] = [];;
  @ViewChild(EditFeeComponent, { static: true }) editFeeComponent: EditFeeComponent;
  id: number;
  sipId: number;
  Constant = Constant;
  isSaved: boolean = false;
  programType: any;
  isSIP: boolean = false;
  sourcePrograms: any[] = [{id: 1, name: 'Linh Hoạt', code: 'NORMAL'}, { id: 2, name: 'Định kỳ', code: 'SIP'}];
  constructor(
      public router: Router,
      public route: ActivatedRoute,
      public productService: ProductService,
      public dataService: DataService,
      public masterDataProductService: MasterDataProductService,
      public toastrService: ToastrService,
      public validateService: ValidateService,
      public eventManager: EventManager,
      public modalService: NzModalService
  ) {
    super(eventManager, route);
  }
  ngOnInit() {
    const data = this.route.snapshot.data;
    this.isSIP = data.isSip;
    if (data.isSip) {
      this.programType = this.sourcePrograms[1];
    } else {
      this.programType = this.sourcePrograms[0];
    }
    super.ngOnInit();
  }
  getBefore() {
    this.fees = this.currentFees.filter((item, index) => {
      return new Fee(item) ;
    });
  }
  disabledButton() {
    this.errors.noFee = !(this.fees || []).length;
    if (this.errors.noFee) {
      this.toastrService.error('Vui lòng nhập đầy đủ và đúng phí!');
    }
    this.errors.startDate = !this.startDate;
    if (this.errors.startDate) {
      this.toastrService.error('Ngày áp dụng không đúng!');
    }
    this.errors.fees = this.fees.some(item => item.fee === undefined || (item.beginValue === 0 && item.endValue === null));
    return super.disabledButton();
  }
  checkDelete() {
  }
  save() {
    this.isSaved = true;
    this.fees = this.editFeeComponent.emitData();
    if (this.disabledButton()) {
      return;
    }
    const body: any = {
      "clientApiKey": "LOCAL",
      "typeCode": "SELL",
      "productId": this.id,
      "destProductId": undefined,
      "schemeId": this.programType.id,
      "programId": null,
      "feeUnitCode": this.fees[0].feeUnitCode,
      "applyAt": this.startDate,
      "details": this.fees
    }
    return this.productService.createProductFeeTemp(body)
    .subscribe((res: any) => {
      this.toastrService.success('Lưu phí mới thành công!');
    });
  }
  delete() {
    const body: any = {
      "clientApiKey": "LOCAL",
      "typeCode": "SELL",
      schemeId: this.programType.id,
      "productId": this.id,
    }
    return this.productService.deleteProductFeeTemp(body)
    .subscribe((res: any) => {
      this.toastrService.success('Xóa phí mua mới thành công!');
      this.currentFees = [];
      this.fees = this.currentFees.slice();
      this.startDate = null;
    });
  }
}
